import splide from "@splidejs/splide";
import "@splidejs/splide/css/core";

export default function sliders() {
	const bannerSlider = document.querySelectorAll(".js-banner-slider");

	if (bannerSlider.length) {
		bannerSlider.forEach((slider) => {
			new splide(slider, {
				type: "loop",
				perPage: 1.5,
				autoplay: true,
				arrows: true,
				pagination: false,
				gap: "1rem",
				focus: "center",
				breakpoints: {
					768: {
						perPage: 1,
						gap: "1rem",
						arrows: false,
						pagination: true,
					},
				},
			}).mount();
		});
	}

	const playerSlider = document.querySelectorAll(".js-players-slider");

	if (playerSlider.length) {
		playerSlider.forEach((slider) => {
			let sliderInstance = new splide(slider, {
				type: "loop",
				perPage: 1,
				autoplay: true,
				arrows: true,
				pagination: false,
				gap: "1rem",
			});

			sliderInstance.mount();

			// .js-prev-name and .js-next-name are the classes of the previous and next buttons where data-name attribute on each slide needs adding, as you move through the slides the data-name attribute will need to update to reflect the new next/previous slide name
			let prevName = document.querySelector(".js-prev-name");
			let nextName = document.querySelector(".js-next-name");

			// Function to update prev/next names
			const updateNames = () => {
				let activeSlide = sliderInstance.Components.Elements.slides[sliderInstance.index];
				let nextSlide = activeSlide.nextElementSibling;
				let prevSlide = activeSlide.previousElementSibling;

				if (nextSlide) {
					nextName.textContent = nextSlide.dataset.name;
				} else {
					nextName.textContent = sliderInstance.Components.Elements.slides[0].dataset.name;
				}

				if (prevSlide) {
					prevName.textContent = prevSlide.dataset.name;
				} else {
					prevName.textContent = sliderInstance.Components.Elements.slides[sliderInstance.Components.Elements.slides.length - 1].dataset.name;
				}
			};

			// Update names on initial load
			updateNames();

			// Update names when slide changes
			sliderInstance.on("moved", updateNames);
		});
	}

	const galleryContainer = document.querySelectorAll(".js-gallery-slider-container");

	if (galleryContainer.length) {
		galleryContainer.forEach((gallery) => {
			const galleryMain = gallery.querySelector(".js-gallery-slider-main");
			const galleryThumbnails = gallery.querySelector(".js-gallery-slider-thumbnails");

			var main = new splide( galleryMain, {
				type: 'fade',
				heightRatio: 0.6,
				pagination: false,
				arrows: false,
				cover: true,
			});

			var thumbnails = new splide( galleryThumbnails, {
				rewind: true,
				perPage: 6,
				isNavigation: true,
				gap: 10,
				focus: 'center',
				pagination: false,
				cover: true,
				dragMinThreshold: {
					mouse: 4,
					touch: 10,
				},
				breakpoints: {
					1024: {
						perPage: 5,
					},
					768: {
						perPage: 4,
					},
					640: {
						perPage: 3,
					},
				},
			});

			main.sync( thumbnails );
			main.mount();
			thumbnails.mount();
		});
	}
}
